import { string } from 'prop-types';

import Image from '~/components/Image';

import style from './ButtonedPopupTemplate.module.scss';

function ButtonedPopupTemplate({ path, headline, message }) {
  return (
    <div className={style.content}>
      <Image
        path={path}
        alt="Reward image"
        className={style.image}
      />
      <div className={style.headline}>{headline}</div>
      <div className={style.message}>{message}</div>
    </div>
  );
}

ButtonedPopupTemplate.propTypes = {
  headline: string.isRequired,
  message: string.isRequired,
  path: string.isRequired,
};

export default ButtonedPopupTemplate;
